var VCA = VCA || {};

VCA.BrandPillars = (function ($) {

    var MEDIA_QUERY = '(max-width: 767px)';
    var mql = window.matchMedia(MEDIA_QUERY);
    var scrollingIsThrottled = false;
    var sticker = $('.brand-pillars__item__link');

    function bindEvents() {
        $('.brand-pillars__list').on('scroll', initScrollDetection);
    }

    function initScrollDetection() {
        var stickers_width = $(this).width();
        if (!scrollingIsThrottled && mql.matches) {
          scrollingIsThrottled = true;
      
          var StickerMatchingExpression = sticker.filter(function() {
            var $this = $(this);
            var left_of_element = $this.offset().left;
            var right_of_element = left_of_element + $this.width();
            return 0 <= left_of_element && right_of_element <= stickers_width;
          });

          if (StickerMatchingExpression[0] !== undefined) {
            $('.brand-pillars__item__link').each((idx,link) => {
                $(link).removeClass('active');
            });
            StickerMatchingExpression.addClass('active');
          }

          scrollingIsThrottled = false;
        }
    }

    function addActiveClass() {
        if (mql.matches) {
            let firstLink = $('.brand-pillars__item__link')[0];
            $(firstLink).addClass('active');
        }
    }

    function init() {
        if ($('.brand-pillars').length <= 0) {
            return;
        }

        bindEvents();
        addActiveClass();
    }

    return {
        init: init
    };

})(jQuery);


$(function () {
    VCA.BrandPillars.init();
});
